module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('list', {
    staticClass: "index-list",
    style: ({
      height: _vm._px2rem(_vm.height + 'px', 75)
    }),
    attrs: {}
  }, [_c('section', {
    staticClass: " weex-ct weex-cell",
    attrs: {
      "weex-type": "cell"
    }
  }, [_vm._t("head", null, {})], 2), _vm._v(" "), _vm._l((_vm.formatList), function(v, i) {
    return _c('section', {
      key: i,
      ref: 'index-item-title-' + v.title,
      refInFor: true,
      staticClass: " weex-ct weex-cell",
      attrs: {
        "weex-type": "cell"
      }
    }, [(!_vm.onlyShowList) ? _c('p', {
      staticClass: " weex-el weex-text",
      class: ['index-list-title', v.type && v.type == 'group' && 'group-title'],
      style: (_vm._processExclusiveStyle(_vm.headerStyle, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(v.title))]) : _vm._e(), _vm._v(" "), (v.type && v.type === 'group' && !_vm.onlyShowList) ? _c('div', {
      staticClass: "group weex-ct weex-div",
      style: (_vm._px2rem(_vm.groupWrapStyle, 75)),
      attrs: {
        "weex-type": "div"
      }
    }, _vm._l((v.data), function(group, index) {
      return _c('div', {
        key: index,
        staticClass: "group-list weex-ct weex-div",
        attrs: {
          "weex-type": "div"
        }
      }, _vm._l((group), function(item, i) {
        return _c('div', {
          key: i,
          staticClass: "group-item weex-ct weex-div",
          style: (_vm._px2rem(_vm.groupItemStyle, 75)),
          attrs: {
            "accessible": true,
            "aria-label": ((item.name) + "," + (item.desc?item.desc:'')),
            "weex-type": "div",
            "data-evt-click": ""
          },
          on: {
            "click": _vm.$stopOuterA,
            "weex$tap": function($event) {
              $event.stopPropagation();
              return _vm.itemClicked(item)
            }
          }
        }, [(item.isLocation) ? _c('figure', {
          staticClass: "location-icon weex-el weex-image",
          attrs: {
            "src": "https://gw.alicdn.com/tfs/TB1JUiUPFXXXXXUXXXXXXXXXXXX-32-32.png",
            "data-img-src": "https://gw.alicdn.com/tfs/TB1JUiUPFXXXXXUXXXXXXXXXXXX-32-32.png",
            "weex-type": "image"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: " weex-ct weex-div",
          attrs: {
            "weex-type": "div"
          }
        }, [_c('p', {
          staticClass: "item-name weex-el weex-text",
          style: (_vm._processExclusiveStyle(_vm.groupItemTextStyle, 75, 'text')),
          attrs: {
            "weex-type": "text"
          }
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.desc) ? _c('p', {
          staticClass: "item-desc weex-el weex-text",
          style: (_vm._processExclusiveStyle(_vm.groupItemDescStyle, 75, 'text')),
          attrs: {
            "weex-type": "text"
          }
        }, [_vm._v(_vm._s(item.desc))]) : _vm._e()])])
      }), 0)
    }), 0) : _vm._e(), _vm._v(" "), (v.type === 'list') ? _c('div', {
      staticClass: " weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, _vm._l((v.data), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "index-list-item weex-ct weex-div",
        style: (_vm._px2rem(_vm.itemStyle, 75)),
        attrs: {
          "accessible": true,
          "aria-label": ((item.name) + "," + (item.desc?item.desc:'')),
          "weex-type": "div",
          "data-evt-click": ""
        },
        on: {
          "click": _vm.$stopOuterA,
          "weex$tap": function($event) {
            $event.stopPropagation();
            return _vm.itemClicked(item)
          }
        }
      }, [_c('p', {
        staticClass: "title weex-el weex-text",
        style: (_vm._processExclusiveStyle(_vm.itemTextStyle, 75, 'text')),
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
        staticClass: "desc weex-el weex-text",
        style: (_vm._processExclusiveStyle(_vm.itemDescStyle, 75, 'text')),
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(item.desc))])])
    }), 0) : _vm._e()])
  }), _vm._v(" "), (_vm.isIPhoneX) ? _c('section', {
    staticClass: "iphone-x weex-ct weex-cell",
    attrs: {
      "weex-type": "cell"
    }
  }) : _vm._e()], 2), _vm._v(" "), (_vm.showIndex && !_vm.onlyShowList) ? _c('div', {
    staticClass: "index-list-nav weex-ct weex-div",
    style: (_vm._px2rem(_vm.navStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.formatList), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "list-nav-key weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.navTextStyle, 75, 'text')),
      attrs: {
        "title": item.title,
        "weex-type": "text",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.go2Key(item.title)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.popKeyShow) ? _c('div', {
    staticClass: "index-list-pop weex-ct weex-div",
    style: (_vm._px2rem(_vm.popStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "list-pop-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.popTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.popKey))])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f64202b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f64202b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-indexlist/index.vue
// module id = 618
// module chunks = 0 1